import { render, staticRenderFns } from "./CadastroSecretaria.vue?vue&type=template&id=beb5cad8&scoped=true"
import script from "./CadastroSecretaria.vue?vue&type=script&lang=ts"
export * from "./CadastroSecretaria.vue?vue&type=script&lang=ts"
import style0 from "./CadastroSecretaria.vue?vue&type=style&index=0&id=beb5cad8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beb5cad8",
  null
  
)

export default component.exports